import { MeiliSearch } from "meilisearch";

export const searchClient = new MeiliSearch({
  host: process.env.REACT_APP_MEILISEARCH_URL || "x",
  apiKey: process.env.REACT_APP_MEILISEARCH_KEY || "x", // Use the public key not the private or master key to search.
});
